"use strict";

import angular from "angular";

function forceNegativeDirective() {
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ctrl) {
            const forceNegative = attrs.forceNegative || false;
            const isNegativeNature = JSON.parse(forceNegative);

            // Função para forçar valor negativo
            function forceNegativeValue() {
                if (isNegativeNature) {
                    const currentValue = ctrl.$modelValue;
                    const input = element[0];
                    const value = input.value;

                    // Se o valor está vazio, nulo, zero ou NaN, define como -0
                    if (
                        isNaN(currentValue) ||
                        currentValue === "" ||
                        currentValue === 0 ||
                        currentValue === null
                    ) {
                        const value = `-0`;
                        ctrl.$setViewValue(value);
                        ctrl.$render();
                        setTimeout(() => {
                            element[0].setSelectionRange(10, 10, "right");
                        });
                    }
                    // Se o valor é positivo, torna negativo
                    else if (currentValue > 0) {
                        const correctedValue = "-" + value;
                        ctrl.$setViewValue(correctedValue);
                        ctrl.$render();
                    }
                }
            }

            // Função para proteger o sinal negativo
            function protectNegativeSign(event) {
                if (isNegativeNature) {
                    const input = element[0];
                    const value = input.value;
                    const selectionStart = input.selectionStart;
                    const selectionEnd = input.selectionEnd;

                    // Se está tentando deletar/backspace na posição do sinal negativo
                    if (value.startsWith("-")) {
                        // Backspace (keyCode 8) na posição 0 ou 1
                        if (event.keyCode === 8 && selectionStart <= 1) {
                            event.preventDefault();
                            return false;
                        }
                        // Delete (keyCode 46) na posição 0
                        if (event.keyCode === 46 && selectionStart === 0) {
                            event.preventDefault();
                            return false;
                        }
                        // Se há seleção que inclui o sinal negativo
                        if (selectionStart === 0 && selectionEnd > 0) {
                            event.preventDefault();
                            return false;
                        }
                    }
                }
            }

            // Bloqueia teclas que podem remover o sinal negativo
            element.on("keydown", function (event) {
                if (isNegativeNature) {
                    // Código 189 = tecla hífen/menos no teclado principal
                    // Código 109 = tecla menos no teclado numérico
                    if (event.keyCode === 189 || event.keyCode === 109) {
                        event.preventDefault();
                        return false;
                    }

                    // Protege contra delete/backspace no sinal negativo
                    protectNegativeSign(event);

                    // Bloqueia Ctrl+A se o campo tem sinal negativo
                    if (event.ctrlKey && event.keyCode === 65) {
                        const input = element[0];
                        if (input.value.startsWith("-")) {
                            event.preventDefault();
                            // Seleciona apenas os números, não o sinal
                            setTimeout(() => {
                                input.setSelectionRange(1, input.value.length);
                            });
                            return false;
                        }
                    }
                }
            });

            // Bloqueia a colagem de texto que contenha o caractere -
            element.on("paste", function (event) {
                if (isNegativeNature) {
                    const clipboardData =
                        event.originalEvent.clipboardData ||
                        window.clipboardData;
                    const pastedText = clipboardData.getData("text");

                    // Se o texto colado contém hífen, bloqueia a colagem
                    if (pastedText.includes("-")) {
                        event.preventDefault();
                        return false;
                    }
                }
            });

            // Intercepta tentativas de seleção que incluam o sinal negativo
            element.on("mousedown", function (event) {
                if (isNegativeNature) {
                    const input = element[0];
                    const value = input.value;

                    if (value.startsWith("-")) {
                        setTimeout(() => {
                            const selectionStart = input.selectionStart;
                            const selectionEnd = input.selectionEnd;

                            // Se a seleção inclui o sinal negativo, ajusta para começar após ele
                            if (selectionStart === 0 && selectionEnd > 0) {
                                input.setSelectionRange(1, selectionEnd);
                            }
                        });
                    }
                }
            });

            // Evento de focus (mantém comportamento original)
            element.on("focus", function () {
                scope.$applyAsync(forceNegativeValue);
            });

            // Evento de blur (mantém comportamento original)
            element.on("blur", function () {
                scope.$applyAsync(forceNegativeValue);
            });

            // Evento de input para capturar mudanças durante a digitação
            element.on("input", function () {
                scope.$applyAsync(() => {
                    const input = element[0];
                    const value = input.value;

                    // Se o valor não começa com - e deveria ser negativo, corrige
                    if (
                        isNegativeNature &&
                        value &&
                        !value.startsWith("-") &&
                        value !== "0"
                    ) {
                        const correctedValue = "-" + value;
                        ctrl.$setViewValue(correctedValue);
                        ctrl.$render();
                    } else {
                        forceNegativeValue();
                    }
                });
            });

            // Intercepta mudanças no modelo
            ctrl.$parsers.push(function (value) {
                if (
                    isNegativeNature &&
                    value !== undefined &&
                    value !== null &&
                    value !== ""
                ) {
                    const numericValue = parseFloat(value);
                    if (!isNaN(numericValue) && numericValue > 0) {
                        return -Math.abs(numericValue);
                    }
                }
                return value;
            });
        }
    };
}

const name = "forceNegative";
const factory = forceNegativeDirective;
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
